export default class ExportWordEvidencePdfRequestDTO {
  linkId: number;

  showCompanyLogo: boolean;

  showEvidenceHeader: boolean;

  showAdditionalDetails: boolean;

  enableLinks: boolean;

  documentTitleLabel: string;

  versionLabel: string;

  approvalStatusLabel: string;

  approvedByLabel: string;

  approvedAtLabel: string;

  ownerLabel: string;

  sharePointSourceUrlLabel: string;

  exportedByLabel: string;

  exportedAtLabel: string;

  constructor() {
    this.linkId = 0;
    this.showCompanyLogo = true;
    this.showEvidenceHeader = true;
    this.showAdditionalDetails = false;
    this.enableLinks = true;
    this.documentTitleLabel = '';
    this.versionLabel = '';
    this.approvalStatusLabel = '';
    this.approvedByLabel = '';
    this.approvedAtLabel = '';
    this.ownerLabel = '';
    this.sharePointSourceUrlLabel = '';
    this.exportedByLabel = '';
    this.exportedAtLabel = '';
  }
}
